import styled from 'styled-components';
import { Button, Form } from 'antd';
import { IToken } from 'store/ducks/globalTypes';
import { CloseCircleOutlined } from '@ant-design/icons';
import Background from 'assets/img/done.png';

export const StyledContainer = styled('div')<IToken>`
  overflow-y: hidden;
  background: ${(props) => props.token.colorBgLayout};
  margin-left: auto;
  margin-right: auto;
  background-size: cover;
  padding-top: 20px;
  min-height: 100vh;

  .ant-pagination {
    margin: 10px 0;
  }

  .ant-row {
    gap: 10px;
  }

  a button {
    margin-left: 20px;
  }
`;

export const StyledLinkButton = styled(Button)<IToken>`
  padding: unset;
  line-height: inherit;
  margin-right: ${(props) => `${props.token.marginXXS}px`};

  > span {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;

export const StyledButton = styled(Button)<IToken>`
  min-width: 100%;
  margin-top: ${(props) => `${props.token.marginXS}px`};
  border-radius: ${(props) => `${props.token.borderRadiusSM}px !important`};

  span {
    font-size: 14px;
  }
`;

export const StyledFormItem = styled(Form.Item)<IToken>`
  margin-bottom: ${(props) => `${props.token.margin}px`};

  .ant-input,
  .ant-input-affix-wrapper {
    padding: 8px 10px;
    border-radius: ${(props) => `${props.token.borderRadiusSM}px`};
    background: #ffffff;
  }

  .ant-col {
    min-width: 100%;
  }
  .ant-input-suffix {
    display: flex;
    svg {
      color: black;
    }
  }
`;

export const FormContainer = styled('div')<IToken>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  background: white;
  padding: 20px 0;
  min-height: 100%;
  border: 1px solid #5a6f94;
  color: ${(props) => props.token.colorText};

  svg {
    color: white;
  }

  > .ant-typography {
    margin: 0;
    color: ${(props) => props.token.colorText};
  }

  .ant-input-search {
    margin: 16px;
    max-width: 160px;
  }

  .ant-input-search input {
    color: ${(props) => props.token.colorText} !important;
  }

  .ant-row {
    justify-content: space-between;

    a span {
      color: ${(props) => props.token.colorText};
    }
  }

  .ant-select-selector {
    color: ${(props) => props.token.colorText} !important;
  }

  .ant-select-selection-item {
    color: ${(props) => props.token.colorText} !important;
  }

  > .ant-form {
    @media (min-width: 1300px) {
      min-width: 315px;
    }
  }
`;

export const IconContainer = styled('div')<IToken>`
  background: ${(props) => props.token.colorPrimary};
  padding: ${(props) => `${props.token.paddingSM}px`};
  border-radius: 50%;

  > span {
    font-size: ${(props) => `${props.token.fontSizeXL}px`};
    color: ${(props) => props.token.colorPrimaryText};
  }
`;

export const InputForm = styled('div')`
 position: relative,
 margin-bottom: 20px
`;

export const ActiveUsers = styled('div')`
  margin-top: 24px;

  .ant-transfer {
    display: flex;
    flex-direction: row;
    gap: 16px;

    @media (max-width: 1240px) {
      flex-direction: column;
    }
  }

  .ant-transfer-list {
    flex: 1;
    min-width: 0;

    .ant-wave-target {
      border: 1px solid;
    }
  }
`;

export const SubmitContainer = styled('div')`
  width: fit-content;
  margin: auto;
`;
export const CustomWrapper = styled('div')`
  display: flex;
  align-items: center;
`;

export const ViewUsersContainer = styled('span')<IToken>`
  padding: 10px;
  width: -webkit-fill-available;
  overflow: scroll;
  height: 600px;

  .ant-list-item {
    border-bottom: 1px solid;
  }

  .ant-typography {
    padding: 0;
    color: ${(props) => props.token.colorText};
  }

  .ant-list-item-meta-title {
    color: ${(props) => props.token.colorText};
  }

  .ant-list-item-meta-description {
    color: ${(props) => props.token.colorText};
  }

  .ant-typography {
    color: ${(props) => props.token.colorText} !important;
  }
  .ant-list-item-meta-title {
    color: ${(props) => props.token.colorText} !important;
  }
  .ant-list-item-meta-description {
    color: ${(props) => props.token.colorText} !important;
  }
`;

export const CloseCircleOutlinedIcon = styled(CloseCircleOutlined)`
  margin-left: 8px;
  font-size: 18px;
  color: #ff4d4f;
  cursor: pointer;
`;
export const UsersData = styled('div')<IToken>`
  margin-bottom: 8px;
  color: ${(props) => props.token.colorText};

  color: ${(props) => props.token.colorText} !important;
`;
